























import mixins from 'vue-typed-mixins';
import Draggable from 'vuedraggable';
export default mixins().extend({
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array as () => any[],
    },
  },
  computed: {
    internal: {
      get(): any[] {
        return this.value;
      },
      set(value: any[]) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    value(prev, next) {
      this.$emit('input', this.value); // this simply forces the input event to trigger when value is updated (trigger dirty flag on validation observer)
    },
  },
});
